import React, { useState } from 'react'
import { Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import { useNotify } from 'react-admin'
import { setBillingAccountBrevoCompanyID } from '../../../Services/brevoCrm'

interface Props {
	billingAccount: any
	onChanged?: () => void
}

// BillingAccountBrevo affiche et permet de modifier manuellement le
// brevo_company_id rattaché au BA. Cas d'usage : Company Brevo créée à la
// main par le sales avant la création du BA Quanti, qu'on veut rattacher
// rétroactivement. Aussi : forcer le rattachement à une autre Company.
export const BillingAccountBrevo: React.FC<Props> = ({ billingAccount, onChanged }) => {
	const notify = useNotify()
	const [value, setValue] = useState<string>(billingAccount.brevoCompanyId ?? '')
	const [saving, setSaving] = useState(false)

	const dirty = value !== (billingAccount.brevoCompanyId ?? '')

	const handleSave = async () => {
		setSaving(true)
		try {
			await setBillingAccountBrevoCompanyID(billingAccount.id, value.trim())
			notify(value ? 'Brevo Company ID saved' : 'Brevo Company ID cleared', { type: 'success' })
			onChanged?.()
		} catch (err: any) {
			notify(err?.message || 'Failed to update Brevo Company ID', { type: 'error' })
		} finally {
			setSaving(false)
		}
	}

	return (
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Brevo CRM
				</Typography>
				<Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
					ID alphanumérique de la Company Brevo liée à ce billing account. Renseigné
					automatiquement à la création du BA si l'auto-provisioning fonctionne.
					Saisir manuellement pour rattacher rétroactivement un BA à une Company
					existante côté Brevo.
				</Typography>
				<Stack direction="row" spacing={1} alignItems="center">
					<TextField
						size="small"
						label="Brevo Company ID"
						placeholder="vide pour effacer"
						value={value}
						onChange={(e) => setValue(e.target.value)}
						sx={{ flexGrow: 1 }}
					/>
					<Button
						variant="contained"
						size="small"
						disabled={!dirty || saving}
						onClick={handleSave}
					>
						{saving ? 'Saving…' : 'Save'}
					</Button>
				</Stack>
				{billingAccount.brevoCompanyId && (
					<Box sx={{ mt: 1 }}>
						<Typography variant="caption" color="text.secondary">
							Actuel : <strong>{billingAccount.brevoCompanyId}</strong>
						</Typography>
					</Box>
				)}
			</CardContent>
		</Card>
	)
}
